import { IconWorld } from '@tabler/icons-react';
import { createStubChannel } from '../_stubFactory';

export default createStubChannel({
  id: 'site_widget',
  name: 'Site Widget',
  description: 'Chat embutido no seu site',
  icon: IconWorld,
  color: '#3b82f6',
  gradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
});
